var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_1295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    rx: 20.5,
    fill: "#005C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 8.5C14.2904 8.5 12.4591 9.25857 11.1088 10.6088C9.75857 11.9591 9 13.7904 9 15.7V25.3C9 27.2096 9.75857 29.0409 11.1088 30.3912C12.4591 31.7414 14.2904 32.5 16.2 32.5H25.8C27.7096 32.5 29.5409 31.7414 30.8912 30.3912C32.2414 29.0409 33 27.2096 33 25.3V15.7C33 13.7904 32.2414 11.9591 30.8912 10.6088C29.5409 9.25857 27.7096 8.5 25.8 8.5H16.2ZM15.4 20.5C15.4 19.0148 15.99 17.5904 17.0402 16.5402C18.0904 15.49 19.5148 14.9 21 14.9C22.4852 14.9 23.9096 15.49 24.9598 16.5402C26.01 17.5904 26.6 19.0148 26.6 20.5C26.6 21.9852 26.01 23.4096 24.9598 24.4598C23.9096 25.51 22.4852 26.1 21 26.1C19.5148 26.1 18.0904 25.51 17.0402 24.4598C15.99 23.4096 15.4 21.9852 15.4 20.5ZM26.6 14.9H28.2V13.3H26.6V14.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    rx: 20.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4ff19ba43a5af1a050f4b6a554039286.svg";
export { ForwardRef as ReactComponent };